import React from 'react';
import { ProductId } from 'services/products/types';
import { connect } from 'react-redux';
import { makeSelectProductFieldValue } from 'services/products/selectors';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';

interface OwnProps {
    productId: ProductId;
}

interface ConnectedProps {
    name?: string;
}

type Props = OwnProps & ConnectedProps;

export class ProductsTableRowNameFieldValueComponent extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { name } = this.props;

        if (!name) return null;

        return name;
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    name: makeSelectProductFieldValue('name')
});

export default connect(mapStateToProps)(
    ProductsTableRowNameFieldValueComponent
);
